import EsignatureController from './e-signature.controller';

const ESignature = () => {
  return <EsignatureController />;
};

export default ESignature;
